import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48ceb580"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["name", "value", "checked"]

import { ref } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'href-target',
  props: {
    target: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    selection: {
      type: Object,
      default: null,
    },
    selectionClassName: {
      type: String,
      default: "href-target--selected",
    },
  },
  setup(__props) {

  const props = __props;

  const selected = ref<boolean>(props.selection?.selected);

  const handleClick = (event: MouseEvent) => {

    if(event.target){
      // elements with class "ignore-click" won't open target by default
      if ((event.target as Element).closest('.ignore-click')) {
        event.preventDefault();
        return;
      }
    }

    // goto target
    if (props.target && !props.disabled) {
      location.href = props.target;
    }

    // selectable
    if (props.selection) {
      selected.value = !selected.value;
    }
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["components__href-target", {
      'href-target--disabled': __props.disabled,
      'href-target--active': !__props.disabled && __props.target,
      [__props.selectionClassName]: selected.value,
    }]),
    onClick: handleClick
  }, [
    (__props.selection)
      ? (_openBlock(), _createElementBlock("input", {
          key: 0,
          class: "selection-checkbox",
          type: "checkbox",
          name: __props.selection.name,
          value: __props.selection.value,
          checked: selected.value
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})